<template>
    <Title>Public Site</Title>
    <main class="flex flex-col h-screen">
        <section class="flex-1 px-6 md:px-20 py-10"><slot></slot></section>
    </main>
    <ModalsContainer />
</template>


<script setup>
import Button from "~/components/ui/Button.vue";
import SearchInput from "~/components/ui/SearchInput.vue";
import { ModalsContainer } from 'vue-final-modal';
const route = useRoute()

</script>
